module.exports = __webpack_public_path__ + "static/img/page_10.c2293392.png";